import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Image,
    Input,
    Link as LinkStyle,
    Text
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Redirect } from "react-router-dom";
import { LanguagePicker } from "../../components/LanguagePicker";
import { useAuthToken, useLogin } from "../../hooks";
import { usePushNotification } from "../../hooks/usePushNotification";
import AuthPage from "../../layouts/Authentication";

const LoginPage: React.FC = ({ children }) => {
    const { t, i18n } = useTranslation();
    const { token, setAuthToken, removeAuthToken, removeRole } = useAuthToken();
    // @ts-ignore
    const [login, { error }] = useLogin();
    const { setPushNotificationToken } = usePushNotification();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [tfaCode, setTfaCode] = useState("");

    const requiresTfaCode = error?.message?.indexOf("4 shifëror") >= 0;

    const handleSubmit = async (event) => {
        event.preventDefault();
        // @ts-ignore
        removeAuthToken();
        removeRole();
        // @ts-ignore
        await login(email, password, tfaCode);
        await setPushNotificationToken();
    };

    return (
        <AuthPage>
            <Flex width="full" align="center" justifyContent="center" marginTop={ 20 }>
                <Box
                    p={ 5 }
                    background="white"
                    borderWidth={ 1 }
                    borderRadius={ 8 }
                    boxShadow="lg"
                    w={ [300, 300, 400, 420, 430] }
                >
                    <Box textAlign="center">
                        <Image src="/logo-white.png" />
                        <Heading>{ t("login.login") }</Heading>
                        <Text>
                            { t("login.noAccount") }{ " " }
                            <LinkStyle>
                                <Link to="/register">{ t("login.register") }</Link>
                            </LinkStyle>
                        </Text>
                    </Box>
                    <Box my={ 4 } textAlign="left">
                        <form onSubmit={ handleSubmit }>
                            <FormControl isRequired>
                                <FormLabel>{ t("login.email") }</FormLabel>
                                <Input
                                    type="email"
                                    placeholder="test@test.com"
                                    onChange={ (event) => setEmail(event.currentTarget.value) }
                                />
                            </FormControl>
                            <FormControl mt={ 6 } isRequired>
                                <FormLabel>{ t("login.password") }</FormLabel>
                                <Input
                                    type="password"
                                    placeholder="*******"
                                    onChange={ (event) => setPassword(event.currentTarget.value) }
                                />
                            </FormControl>
                            { requiresTfaCode ? (
                                <FormControl mt={ 6 }>
                                    <FormLabel>{ t("login.tfaCode") }</FormLabel>
                                    <Input
                                        type="text"
                                        placeholder="XXXX"
                                        required={ false }
                                        onChange={ (event) => setTfaCode(event.currentTarget.value) }
                                    />
                                </FormControl>
                            ) : null }

                            <Button
                                type="submit"
                                variantColor="teal"
                                variant="outline"
                                width="full"
                                mt={ 4 }
                            >
                                { t("login.login") }
                            </Button>
                        </form>

                        <Box textAlign="center" m={ 5 }>
                            <Text>
                                { t("login.forgotPassword") }{ " " }
                                <LinkStyle>
                                    <Link to="/reset-password">{ t("login.resetPassword") }</Link>
                                </LinkStyle>
                            </Text>
                        </Box>
                    </Box>

                    <LanguagePicker />
                </Box>
            </Flex>
        </AuthPage>
    );
};

export default LoginPage;
